import { useState } from "react";
import { userObject, validateUser } from "../../network/lib/user";
import { useNavigate } from "react-router-dom";
import { EncryptJson } from "../utils/encryDecry";
import { setAuth } from "../utils/auth";

function Login() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const setToDefault = () => {
    setUserName("");
    setPassword("");
  };

  const handleCancel = (e) => {
    e.preventDefault();

    let message = document.getElementById("message");
    message.innerHTML = "";

    setToDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let message = document.getElementById("message");
    message.innerHTML = "";

    if (!userName) {
      message.innerHTML = "Please enter UserName";
    } else if (!password) {
      message.innerHTML = "Please enter Password";
    } else {
      userObject.userName = userName;
      userObject.password = password;

      validateUser(userObject).then((res) => {
        if (res.status == 200 && res.data) {
          const userData = res.data;
          setAuth({
            userName: userData.userName,
            role: userData.role,
            roleId: userData.roleId,
          });
          navigate("/admin");
        } else {
          message.innerHTML = "UserName or Password is wrong";
          setToDefault();
        }
      });
    }
  };

  const contents = (
    <form onSubmit={handleSubmit}>
      <table style={{ width: "30%", height: "256px" }}>
        <tbody>
          <tr>
            <th align="center" colSpan="2">
              Login
            </th>
          </tr>
          <tr>
            <td align="right" width="40%">
              <span className="required">UserName</span>
            </td>
            <td width="50%">
              <input
                name="userName"
                type="text"
                value={userName}
                id="userName"
                onChange={(e) => setUserName(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td align="right" width="40%">
              <span className="required">Password</span>
            </td>
            <td width="50%">
              <input
                name="password"
                type="password"
                value={password}
                id="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}></td>
            <td style={{ textAlign: "right" }}>
              <input
                className="btn"
                type="button"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              <input
                className="btn"
                type="submit"
                value="Login"
                id="btnSubmit"
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  );

  return contents;
}

export default Login;
